import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import CloseIcon from 'mdi-react/CloseCircleOutlineIcon';

import './tag.scss';

const styles = bemGenerator('pj-ui-tag', ['value', 'group', 'close']);
const CLEAR = 'clear';
const DEFAULT = 'default';

const Tag = ({ value, groupName, type, onClick }) => {
  const isClearTag = {
    clear: type === CLEAR,
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.block.withModifier(isClearTag)}
    >
      {groupName && type !== CLEAR && (
        <span className={styles.group}>{groupName}:</span>
      )}
      <span className={styles.value.withModifier(isClearTag)}>{value}</span>
      {type !== CLEAR && (
        <span className={styles.close}>
          <CloseIcon size={16} color="#fff" />
        </span>
      )}
    </button>
  );
};

const { string, oneOf, func } = PropTypes;
Tag.propTypes = {
  value: string.isRequired,
  groupName: string,
  type: oneOf([DEFAULT, CLEAR]),
  onClick: func,
};
Tag.defaultProps = {
  groupName: undefined,
  type: DEFAULT,
  onClick: () => {},
};

export default Tag;
